import React from 'react';
import { node, string, bool } from 'prop-types';
import cn from 'clsx';
import { designTokenPropTypes } from '@immediate_media/design-tokens';
import { useDesignTokens } from '../../hooks/index.js';

/**
 * BackgroundContainer component.
 */
const BackgroundContainer = ({
  children,
  className,
  color,
  hasTopBorder,
  hasBottomBorder
}) => {
  const {
    colors
  } = useDesignTokens();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('background-container', className),
    style: {
      ...(color && {
        backgroundColor: colors[color]
      })
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cn("background-container__inner container--no-gutters", className),
    style: {
      ...(color && {
        backgroundColor: colors[color]
      }),
      ...(hasTopBorder && {
        marginTop: -1
      }),
      ...(hasBottomBorder && {
        marginBottom: -1
      })
    }
  }, children));
};
BackgroundContainer.defaultProps = {
  children: null,
  className: '',
  color: null,
  hasTopBorder: false,
  hasBottomBorder: false
};
BackgroundContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Children to be rendered inside the BackgroundContainer component. */
  children: node,
  /** Additional classes to be added to the root of the component. */
  className: string,
  /** Background colour of the component. */
  color: designTokenPropTypes.color,
  /** Border top style by 1px of the inner container if true. */
  hasTopBorder: bool,
  /** Border bottom style by 1px of the inner container if true. */
  hasBottomBorder: bool
} : {};
export default BackgroundContainer;